export default __webpack_public_path__ + "static/outer_top-db51d49f161d29d63cf273ecee11392e.png";